import { react_api } from "../../config";
import { HTTP_STATUS_CODES } from "../../GrinsCostant";

let toast;
let axiosInstance;
let translator;
// Funzione di inizializzazione per configurare le variabili
export const initMenuStructureHttpService = (translation, t, axiosInst) => {
  translator = translation;
  toast = t;
  axiosInstance = axiosInst;
};

const headersDefault = () => ({
  "Content-Type": "application/json",
  Authorization: sessionStorage.getItem("token"),
});
const baseUrl = `${react_api}/menu-structure`;

export const getByRole = async (role) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/get-by-role`,
      { role: role },
      {
        headers: headersDefault(),
      }
    );

    const result = response.data;

    if (result.status.toString() == HTTP_STATUS_CODES.OK) {
      return result;
    }
  } catch (error) {
    toast({
      title: translator("toastMsg.callError"),
      description: String(error),
      position: "top",
      status: "warning",
      duration: 4000,
      isClosable: true,
    });
  }
};

export const updateByRole = async (role, menu, onCompleteToast) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/get-by-role`,
      { role: role, menu: menu },
      {
        headers: headersDefault(),
      }
    );

    const result = response.data;

    if (result.status.toString() == HTTP_STATUS_CODES.OK) {
      toast({
        title: "Menu Update Successfull",
        status: "success",
        duration: 1500,
        position: "top",
        isClosable: true,
        onCloseComplete: onCompleteToast,
      });

      return result;
    }
  } catch (error) {
    toast({
      title: translator("toastMsg.callError"),
      description: String(error),
      position: "top",
      status: "warning",
      duration: 4000,
      isClosable: true,
    });
  }
};
